import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';


@Component({
	selector: 'app-agent-three-view',
	templateUrl: './agent-three-view.component.html',
	styleUrls: ['./agent-three-view.component.scss']
})
export class AgentThreeViewComponent implements OnInit {

	@Input() type: any;

	user_details: any;

	constructor(
		private storageService: StorageService,
		public commonService: CommonService,
	) { }

	ngOnInit(): void {
		this.user_details = this.storageService.get("user_details");
		this.getSummaryData();
	}

	page_summary_data: any;
	page_summary_data_loaded: boolean = false;
	getSummaryData() {
		this.page_summary_data_loaded = false;

		let route: any = "/agent_3/insights/?screen_type=";

		if (this.type == "Upside Opportunities") {
			route = route + "opportunity";
		} else if (this.type == "Retention Opportunities") {
			route = route + "retention";
		} else if (this.type == "Bank Customers to Investment Clients") {
			route = route + "bank_customers";
		} else if (this.type == "New Prospects") {
			route = route + "new_prospects";
		} else if (this.type == "Bank Customers to Deposit Clients") {
			route = route + "bank_customers";
		} else if (this.type == "Non Customers") {
			route = route + "new_prospects";
		} else if (this.type == "Upside Opportunities MAGI") {
			route = route + "opportunity_magi";
		} else if (this.type == "Retention Opportunities MAGI") {
			route = route + "retention_magi";
		} else if (this.type == "Bank Customers to Investment Clients MAGI") {
			route = route + "bank_customers_magi";
		} else if (this.type == "New Prospects MAGI") {
			route = route + "new_prospects_magi";
		} else if (this.type == "Bank Customers to Deposit Clients MAGI") {
			route = route + "bank_customers_magi";
		} else if (this.type == "Non Customers MAGI") {
			route = route + "new_prospects_magi";
		} else if (this.type == "Marketing Team Bank Customers to Investment Clients Unassigned") {
			route = route + "bank_customers_magi";
		} else if (this.type == "Marketing Team New Prospects Unassigned") {
			route = route + "new_prospects_magi";
		} else if (this.type == "Marketing Team Bank Customers to Deposit Clients Unassigned") {
			route = route + "bank_customers_magi";
		} else if (this.type == "Marketing Team Non Customers Unassigned") {
			route = route + "new_prospects_magi";
		} else if (this.type == "Marketing Team Bank Customers to Investment Clients Assigned") {
			route = route + "bank_customers_magi";
		} else if (this.type == "Marketing Team New Prospects Assigned") {
			route = route + "new_prospects_magi";
		} else if (this.type == "Marketing Team Bank Customers to Deposit Clients Assigned") {
			route = route + "bank_customers_magi";
		} else if (this.type == "Marketing Team Non Customers Assigned") {
			route = route + "new_prospects_magi";
		} else if (this.type == "MAGI (for existing clients)") {
			route = route + "magi";
		}

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.page_summary_data = res["data"];
				this.page_summary_data_loaded = true;
			},
			(err) => {
				this.page_summary_data_loaded = false;
			},
		);
	}

	abbreviateNumber(value) {
		let fixed = 1;
		let num = value;
		if (num === null) {
			return null;
		}
		if (num === 0) {
			return '0';
		}
		fixed = !fixed || fixed < 0 ? 0 : fixed;
		var b = num.toPrecision(2).split('e'),
			k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
			c =
			k < 1
				? num.toFixed(0 + fixed)
				: (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
			d = c < 0 ? c : Math.abs(c),
			e = d + ['', 'K', 'M', 'B', 'T'][k];
		return e;

		// value = Math.round(value);
		// let new_value = value;
		// if (value >= 1000) {
		//     const suffixes = ["", "K", "M", "B","T"];
		//     const suffixNum = Math.floor( (""+value).length/3 );
		//     let shortValue: any = '';
		//     for (var precision = 2; precision >= 1; precision--) {
		//         shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
		//         var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
		//         if (dotLessShortValue.length <= 2) { break; }
		//     }
		//     if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
		//     new_value = shortValue+suffixes[suffixNum];
		// }
		// return new_value;
	}

}
